import React, { useState,useEffect,useMemo } from 'react';
import {
  Radio,
  FormControlLabel,
  FormControl,
  useMediaQuery,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CloseIcon from '@mui/icons-material/Close';

import {
  StyledDialog,
  StyledDialogInputs,
  StyledDialogTitle,
  StyledDialogContent,
  StyledButton,
  StyledDialogCloseButton,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledDialogActions,
  StyledRadioGroup,
  StyledTextField,
  StyledFormLabel,
} from './styles.js';

import InputMask from 'react-input-mask';

const SocialNetworkUpdateModal = ({ open, onClose, onSubmit,socialData}) => {

  const [profileData, setProfileData] = useState({
    instagram: { user: '', type: 'pessoal' },
    tiktok: { user: '', type: 'pessoal' },
    whatsapp: { user: '', type: 'pessoal' },
});
  
  const typeMap = {
    pessoal: 'PERSONAL',
    comercial: 'COMMERCIAL',
  };

  const hasChanges = useMemo(() => {
  if (!socialData) return false;

  const normalized = {
    instagram: {
      user: socialData.instagram_user || '',
      type: socialData.instagram_type === 'COMMERCIAL' ? 'comercial' : 'pessoal',
    },
    tiktok: {
      user: socialData.tiktok_user || '',
      type: socialData.tiktok_type === 'COMMERCIAL' ? 'comercial' : 'pessoal',
    },
    whatsapp: {
      user: socialData.phone || '',
      type: socialData.phone_type === 'COMMERCIAL' ? 'comercial' : 'pessoal',
    },
  };

  const currentPhone = profileData.whatsapp.user.replace(/\D/g, '');
  const originalPhone = normalized.whatsapp.user.replace(/\D/g, '');

  const whatsappChanged = currentPhone !== originalPhone || profileData.whatsapp.type !== normalized.whatsapp.type;
  const whatsappInvalid = currentPhone.length > 0 && currentPhone.length < 11;

  return (
    profileData.instagram.user.trim() !== normalized.instagram.user ||
    profileData.instagram.type !== normalized.instagram.type ||
    profileData.tiktok.user.trim() !== normalized.tiktok.user ||
    profileData.tiktok.type !== normalized.tiktok.type ||
    whatsappChanged ||
    (whatsappChanged && whatsappInvalid)
  );
}, [profileData, socialData]);

 useEffect(() => {
  if (!socialData) return;

  setProfileData({
    instagram: {
      user: socialData.instagram_user || '',
      type: socialData.instagram_type === 'COMMERCIAL' ? 'comercial' : 'pessoal',
    },
    tiktok: {
      user: socialData.tiktok_user || '',
      type: socialData.tiktok_type === 'COMMERCIAL' ? 'comercial' : 'pessoal',
    },
    whatsapp: {
      user: socialData.phone || '',
      type: socialData.phone_type === 'COMMERCIAL' ? 'comercial' : 'pessoal',
    },

  });
}, [socialData]);

  const handleInputChange = (field, subfield) => e => {
    const value = e.target.value;
    setProfileData(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [subfield]: value,
      },
    }));
  };

  const handleSubmit = () => {
    const formattedData = {
      instagram_user: profileData.instagram.user.trim(),
      instagram_type: typeMap[profileData.instagram.type],
      tiktok_user: profileData.tiktok.user.trim(),
      tiktok_type: typeMap[profileData.tiktok.type],
      phone: profileData.whatsapp.user.replace(/\D/g, ''),
      phone_type: typeMap[profileData.whatsapp.type],
    };
  
    onSubmit(formattedData); 
  };

  const isMobile = useMediaQuery('(max-width:600px)');
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <StyledDialogContent>
  
          <StyledDialogCloseButton onClick={onClose}>
            <CloseIcon />
          </StyledDialogCloseButton>
        

        <StyledDialogTitle>
        <strong>Redes Sociais</strong>
        </StyledDialogTitle>

        {isMobile ? (
          <>
            {['instagram', 'tiktok', 'whatsapp'].map(rede => (
              <StyledAccordion disableGutters
                key={rede}
                expanded={expanded === rede}
                onChange={handleAccordionChange(rede)}
              >
                <StyledAccordionSummary
                  expandIcon={expanded === rede ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                >
                  {rede.charAt(0).toUpperCase() + rede.slice(1)}
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                  <FormControl fullWidth>
                    <StyledRadioGroup
                      value={profileData[rede].type}
                      onChange={handleInputChange(rede, 'type')}
                    >
                      <FormControlLabel value="pessoal" control={<Radio />} label="Pessoal" />
                      <FormControlLabel value="comercial" control={<Radio />} label="Comercial" />
                    </StyledRadioGroup>
                     {rede === 'whatsapp' ? (
                    <InputMask
                      mask="(99)99999-9999"
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                    >
                      {(inputProps) => (
                        <StyledTextField
                          {...inputProps}
                          variant="outlined"
                          value={profileData[rede].user}
                          placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                          fullWidth
                          margin="dense"
                        />
                      )}
                    </InputMask>
                  ) : (
                    <StyledTextField
                      variant="outlined"
                      placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                      fullWidth
                      margin="dense"
                    />)}
                  </FormControl>
                </StyledAccordionDetails>
              </StyledAccordion>
            ))}
          </>
        ) : (
          <StyledDialogInputs>
            {['instagram', 'tiktok', 'whatsapp'].map(rede => (
              <FormControl fullWidth key={rede}>
                <StyledFormLabel>{rede.charAt(0).toUpperCase() + rede.slice(1)}:</StyledFormLabel>
                <StyledRadioGroup
                  row
                  value={profileData[rede].type}
                  onChange={handleInputChange(rede, 'type')}
                >
                  <FormControlLabel value="pessoal" control={<Radio />} label="Pessoal" />
                  <FormControlLabel value="comercial" control={<Radio />} label="Comercial" />
                </StyledRadioGroup>
                {rede === 'whatsapp' ? (
                    <InputMask
                      mask="(99)99999-9999"
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                    >
                      {(inputProps) => (
                        <StyledTextField
                          {...inputProps}
                          variant="outlined"
                          value={profileData[rede].user}
                          placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                          fullWidth
                          margin="dense"
                        />
                      )}
                    </InputMask>
                  ) : (
                    <StyledTextField
                      variant="outlined"
                      placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                      fullWidth
                      margin="dense"
                    />)}
                  </FormControl>
            ))}
          </StyledDialogInputs>
        )}

        <StyledDialogActions isMobile={isMobile}>
          <StyledButton fullWidth={isMobile} onClick={handleSubmit}  disabled={!hasChanges}>
            CONFIRMAR
          </StyledButton>
        </StyledDialogActions>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default SocialNetworkUpdateModal;
